import { getTextAdZoneIdMap } from './ads-zone-id-map';
import React from 'react';
import styled from 'styled-components';
import { FlexRow } from '@make-software/cspr-design';
import { AdsBannerInsTag } from './ads-banner-ins-tag';
import { useRouteMatchPath } from '../../router/utils';

const TextAdsBannerContainer = styled(FlexRow)(({ theme }) =>
  theme.withMedia({
    height: ['60px', '20px', '20px'],
    '> ins': {
      display: 'inline-block',
      lineHeight: '20px',
      wordBreak: 'break-word',
    },
    '> ins #sponsored': {
      color: theme.styleguideColors.contentTertiary,
      fontSize: '14px',
      fontWeight: 400,
      marginRight: '4px',
      verticalAlign: 'top',
      display: 'inline',
    },
    '> ins #icon': {
      display: 'inline-block',
      width: '20px',
      height: '20px',
      marginRight: '4px',
    },
    '> ins #text': {
      verticalAlign: 'top',
      color: theme.styleguideColors.contentTertiary,
      fontWeight: 400,
      display: 'inline',
      fontSize: '14px',
    },
    '> ins a ': {
      marginLeft: [0, '4px', 0, '4px'],
      fontWeight: 600,
      fontSize: '14px',
      color: theme.styleguideColors.contentLightBlue,
      verticalAlign: 'top',
      display: 'inline',
    },
  })
);

export const TextAdsBanner = () => {
  const match = useRouteMatchPath();
  const pathname = match.path;

  const networkName = config.network_name;
  const env = config.environment_name;
  const envByNetworkVersion = networkName === 'dev-net' ? 'testnet' : env;

  const zonesIdsByPage = getTextAdZoneIdMap(pathname);
  const zoneId = zonesIdsByPage[envByNetworkVersion];

  return (
    <TextAdsBannerContainer itemsSpacing={4} align={'baseline'}>
      <AdsBannerInsTag zoneId={zoneId} bannerId={'text-banner'} />
    </TextAdsBannerContainer>
  );
};
